<template>
  <GenericRow
    :locked="locked"
    :on-action="submitForm"
    :invalid="$v.section.$invalid"
    :dirty="$v.section.$anyDirty"
    title="Sibling Income"
    :subtitle="subtitle"
  >
    <v-form
      :disabled="locked"
      @submit.prevent="submitForm"
    >
      <v-row>
        <v-col>
          <v-text-field
            v-model="section.first_name"
            autocomplete="off"
            label="First Name"
            outlined
            disabled
          />
        </v-col>
        <v-col>
          <v-text-field
            v-model="section.middle_name"
            autocomplete="off"
            label="Middle Name"
            outlined
            disabled
          />
        </v-col>
        <v-col>
          <v-text-field
            v-model="section.last_name"
            autocomplete="off"
            label="Last Name"
            outlined
            disabled
          />
        </v-col>
        <v-col>
          <v-text-field
            v-model="section.monthly_income"
            autocomplete="off"
            label="Monthly Income"
            outlined
            prefix="$"
            type="number"
            :error-messages="getErrorMessages($v.section.monthly_income)"
            @input="$v.section.monthly_income.$touch()"
            @blur="$v.section.monthly_income.$touch()"
          />
        </v-col>
        <v-col>
          <v-autocomplete
            v-model="section.income_verification"
            :items="optionsIncomeVerification"
            label="Verification"
            outlined
            :error-messages="getErrorMessages($v.section.income_verification)"
            @input="$v.section.income_verification.$touch()"
            @blur="$v.section.income_verification.$touch()"
          />
        </v-col>
      </v-row>
    </v-form>
  </GenericRow>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import { useVuelidate } from '@vuelidate/core'

import { PARTY_NAMESPACE } from '@/store/party'
import { SHARED_NAMESPACE } from '@/store/shared'

import { alertHandler } from '@/alertHandler'

import { partyName } from '@/utilities'

import GenericRow from '@/components/Party/PartyEdit/SectionCards/GenericRow'

export default {
  name: 'SiblingsIncomeRow',
  components: { GenericRow },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  setup () {
    return {
      $v: useVuelidate(),
      ...alertHandler(),
    }
  },

  data () {
    return {
      cached_a_number: null,
    }
  },

  validations () {
    return {
      section: {
        income_verification: {},
        monthly_income: {},
      },
    }
  },

  computed: {
    create () { return this.item.id === null },

    locked: {
      get () {
        return this.peSiblingsIncomeRowLock(this.sectionIdentifier)
      },

      set (value) {
        this.setPeSiblingsIncomeRowLock({ index: this.sectionIdentifier, locked: value })
      },
    },

    optionsIncomeVerification () {
      return this.getCachedDropdown('parties/income_verification')
    },

    section () {
      return this.item
    },

    sectionIdentifier () {
      return this.section.id || 'new'
    },

    subtitle () {
      return `(${partyName(this.section)}) - (${this.subtitleIncome}) (${this.subtitleVerification})`
    },

    subtitleIncome () {
      return this.section.monthly_income ? `$${this.section.monthly_income}` : 'No Monthly Income'
    },

    subtitleVerification () {
      const label = this.optionsIncomeVerification?.find(o => o.value === this.section.income_verification)?.text
      return this.section.income_verification ? `${label}` : 'No Verification'
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peSiblingsIncomeRowLock',
    ]),

    ...mapGetters(SHARED_NAMESPACE, [
      'getCachedDropdown',
    ]),
  },

  created () {
    if (!this.create) this.initPeSiblingsIncomeRow(this.sectionIdentifier)
    this.getDropdownOptions({ path: 'parties/income_verification' })
  },

  methods: {
    getErrorMessages (validator) { return validator?.$errors.map(e => e.$message) },

    onCardUpdate () {
      this.peSiblingsIncomeRowUpdate({ id: this.section.id, index: this.sectionIdentifier, section: this.section }).
        then(() => this.displayAlert('success', 'Marriage Income updated successfully')).
        catch(() => this.displayAlert('error', 'Marriage Income could not be updated'))
    },

    onSectionUnlock () {
      this.setPeSiblingsIncomeRowLock({ index: this.sectionIdentifier, locked: false })
    },

    submitForm () {
      if (this.locked) this.onSectionUnlock()
      else this.onCardUpdate()
    },

    ...mapMutations(PARTY_NAMESPACE, [
      'setPeSiblingsIncomeRowLock',

    ]),

    ...mapActions(PARTY_NAMESPACE, [
      'initPeSiblingsIncomeRow',
      'peSiblingsIncomeRowUpdate',
    ]),

    ...mapActions(SHARED_NAMESPACE, [
      'getDropdownOptions',
    ]),
  },
}
</script>
